import * as PIXI from "pixi.js";
/**
 * RendererConstants.ts
 */
export class RendererConstants {
}
RendererConstants.PROPERTY_RENDERER = "renderer";
RendererConstants.PROPERTY_DEVICE = "device";
RendererConstants.PROPERTY_FORCE_DEVICE = "forceDevice";
/*
 * RendererType.ts
 */
export class RendererType {
}
RendererType.CANVAS = "canvas";
RendererType.WEB_GL = "webgl";
/*
 * RendererDevice.ts
 */
export class RendererDevice {
}
RendererDevice.TABLET = "tablet";
RendererDevice.PHONE = "phone";
/*
 * LobbyDevice.ts
 */
export class LobbyDevice {
}
LobbyDevice.MOBILE = "MOBILE";
LobbyDevice.DESKTOP = "DESKTOP_WEB";
LobbyDevice.MOBILE_WEB = "MOBILE_WEB";
/*
 * OrientationType.ts
 */
export class OrientationType {
}
OrientationType.PORTRAIT = "portrait";
OrientationType.LANDSCAPE = "landscape";
/**
 * DisplayInfo.ts
 */
export class DisplayInfo {
}
DisplayInfo.NAVIGATION_BAR_HEIGHT = 65;
DisplayInfo.FREE_ROUNDS_WIDGET_SIZE = new PIXI.Point(151, 76);
//# sourceMappingURL=RendererConstants.js.map